module.exports = __webpack_public_path__ + "img/tran.1b10b9ea.png";